<template>
	<div>
		<el-row slot="label" type="flex" style="font-size: 16px;line-height: 48px;" justify="space-between">
			<el-col :span="12"><span
					style="color: #3978F4;font-size: 24px;font-weight: bold;margin-right: 18px;">Hi</span>欢迎您来到财天下灵活用工平台</el-col>
			<el-col :span="1" style="font-weight: bold;">首页</el-col>
		</el-row>
		<!--公司 -->
		<el-card v-if="role == 'COMPANY'" style="background-color: #f1f4f5;" shadow="never" class="aui-card--fill">
			<div class="mod-home" style="padding:0">
				<el-row :gutter="24" type="flex" justify="center">
					<el-col :span="12">
						<el-card class="box-card">
							<div slot="header" class="clearfix">
								<span class="h2Title">
									<img src="../../assets/img/card1.png" alt="">
									待办事项
								</span>
							</div>
							<div class="cardCon cardCon1">
								<li @click="fnPayPage">
									<span>{{ allToBePaid }}</span>
									<p>待支付</p>
								</li>
								<li></li>
								<li @click="$router.push({ name: 'plat-platinvoicingtasklist' })">
									<span>{{ data.invoice.wait ? data.invoice.wait : 0 }}</span>
									<p>待开票</p>
								</li>
							</div>
						</el-card>
					</el-col>
					<el-col :span="12">
						<el-card class="box-card">
							<div slot="header" class="clearfix">
								<span class="h2Title">
									<img src="../../assets/img/card2.png" alt="">
									快捷操作
								</span>
							</div>
							<div class="cardCon cardCon2">
								<!-- <li @click="handleSign()" v-if="!data.companyCenter.agreementNo && data.bankInfos[0] && data.bankInfos[0].payChannel == 1">
								<img src="../../assets/img/card01.png" alt="">
								<p>签约</p>
							</li> -->
								<li @click="handleRecharge()">
									<img src="../../assets/img/card01.png" alt="">
									<p>充值</p>
								</li>
								<li @click="qufabu">
									<img src="../../assets/img/card02.png" alt="">
									<p>发布新任务</p>
								</li>
								<li @click="goQuestion">
									<img src="../../assets/img/card03.png" alt="">
									<p>安全设置</p>
								</li>
							</div>

						</el-card>
					</el-col>
				</el-row>
				<h2 class="h2Title" style="margin-top:30px; padding-left:10px;">
					<img src="../../assets/img/card3.png" alt="">
					数据概况
				</h2>
				<el-row :gutter="24" type="flex" justify="center" style="margin-top:20px;">
					<el-col :span="24">
						<el-card class="box-card box-card3">
							<div class="clearfix" v-if="data.transactions.length">
								<el-select class="fr tax-source" v-model="transaction.bodyId" size="small"
									placeholder="请选择" @change="changeTaxSource">
									<el-option v-for="item in data.transactions" :key="item.bodyId"
										:label="item.abbreviation" :value="item.bodyId">
									</el-option>
								</el-select>
							</div>
							<div class="cardCon cardCon3">
								<dl>
									<dt>
										<img src="../../assets/img/card3_1.png" alt="">
									</dt>
									<dd>
										<span>{{ transaction.persons ? transaction.persons : 0 }}</span>
										<p>累计交易总人次(人)</p>
									</dd>
								</dl>
								<dl>
									<dt>
										<img src="../../assets/img/card3_2.png" alt="">
									</dt>
									<dd>
										<span>{{ transaction.transactionsAmount ? transaction.transactionsAmount :
											'0.00'}}</span>
										<p>累计交易总金额(元)</p>
									</dd>
								</dl>
								<dl>
									<dt>
										<img src="../../assets/img/card3_3.png" alt="">
									</dt>
									<dd>
										<span>{{ transaction.balance ? moneyUtils(transaction.balance) : '0.00' }}</span>
										<p>账户余额(元)</p>
										<i class="el-icon-refresh" :class="refreshIcon" @click="refreshbalance"></i>
									</dd>
								</dl>
							</div>

						</el-card>
					</el-col>
				</el-row>
				<!-- <div v-if="data.bankInfos && data.bankInfos[0] && (data.bankInfos[0].bodyId != '1453241566079012865' || data.bankInfos[0].bodyId != '2043514323391295490')">
				<h2 class="h2Title" style="margin-top:30px; padding-left:10px;">
					<img src="../../assets/img/card3.png" alt="">
					电子合同
				</h2>
				<el-row :gutter="24" type="flex" justify="center" style="margin-top:20px;">
					<el-col :span="24" v-if="data && data.companyCenter && data.companyCenter.signUrls">
						<div style="display: flex;flex-wrap: wrap;background: #fff;border-radius: 5px;box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);">
							<div style="padding:30px;width: 33.3%;text-align: center;" v-for="(item,index) in data.companyCenter.signUrls" :key="index">
								<img style="width:150px;height:150px" :src="item.url" />
								<p style="font-size:16px;">{{item.name}}
									<span style="color:#188eee;cursor:pointer;" @click="downloadByBlob(item.url,'二维码')">(下载)</span>
								</p>
							</div>
						</div>
					</el-col>
				</el-row>
			</div> -->
			</div>
			<!-- <div class="mod-home" style="padding:0;">
			<el-row :gutter="20">
				<el-col :span="8">
					<div style="background-color: #fff;border-radius: 8px;height: 335px;">
						<el-row style="padding-top: 30px;">
							<el-col :span="20">
								<span style="margin:0px 5%;font-size: 16px;">任务中心</span>
							</el-col>
							<el-col :span="4">
								<el-button type="primary" style="width: 33px;height: 33px;background-color: #469FFB!important;padding: 0;line-height: 26px!important;text-align: center;margin-left: 20px;" icon="el-icon-refresh" @click="getData()"></el-button>
							</el-col>
						</el-row>
						<el-row style="margin:0px 5%;padding-top: 30px;">
							<el-col :span="12">
								<span style="font-size: 12px;line-height: 28px;">总任务</span><br />
								<span class="fontsize" style="font-size: 40px;font-weight:bold;">{{data.task.total? data.task.total:0}}</span>
							</el-col>
							<el-col :span="12">
								<span style="font-size: 12px;line-height: 28px;">已发布</span><br />
								<span class="fontsize" style="font-size: 40px;font-weight:bold;">{{data.task.published ? data.task.published:0}}</span>
							</el-col>
						</el-row>
						<el-row style="margin:0px 5%;">
							<div style="background-color: #F9F9F9;line-height: 36px;padding: 10px 0;font-size: 12px;">
								<p style="margin: 0;"><span style="width: 10px;height: 10px;border-radius: 5px;background-color: #3371F1;display: inline-block;margin: 0 15px;"></span>发布任务<span style="color: #3371F1;text-decoration: underline;cursor: pointer;margin-left: 25px;" @click="qufabu()">去发布</span></p>
								<p style="margin: 0;"><span style="width: 10px;height: 10px;border-radius: 5px;background-color: #3371F1;display: inline-block;margin: 0 15px;"></span>我发布的任务<span style="color: #3371F1;text-decoration: underline;cursor: pointer;margin-left: 25px;" @click="$router.push({name:'task-task-list-ca'})">去查看</span></p>
							</div>
						</el-row>
					</div>
				</el-col>
				<el-col :span="8" >
					<div style="background-color: #fff;border-radius: 8px;height: 335px;">
						<el-row style="margin:0px 5%;padding-top: 30px;">
							<el-col :span="20">
								<span style="font-size: 16px;">用户中心</span>
							</el-col>
							<el-col :span="4">
								<el-button type="primary" style="width: 33px;height: 33px;background-color: #469FFB!important;padding: 0;line-height: 26px!important;text-align: center;margin-left: 20px;" icon="el-icon-refresh" @click="getData()"></el-button>
							</el-col>
						</el-row>
						<el-row style="margin:0px 5%;">
							<el-row>
								<el-col :span="16">
									<h4 style="margin:0;line-height: 40px;font-size: 14px;margin-top: 20px;" v-if="data.companyCenter.name !='' && data.companyCenter.name !=null ">{{data.companyCenter.name}}，您好</h4>
									<h4 style="margin:0;line-height: 40px;font-size: 14px;margin-top: 20px;" v-else>您好</h4>

									<div style="font-size: 12px;line-height: 34px;">
										<p style="margin: 0;" v-if="data.companyCenter.id!=''">统一社会信用编码：{{data.companyCenter.id}}</p>
										<p style="margin: 0;" v-if="data.companyCenter.mobile!=''">注册电话：{{data.companyCenter.mobile}}</p>
									</div>
								</el-col>
								<el-col :span="8">
									<div style="width:100px;height: 100px;padding-top: 30px;">
										<img :src='require("../../assets/img/wechat.jpg")' style="width: 100%;" />
									</div>
								</el-col>
							</el-row>

							<div style="background-color: #F9F9F9;line-height: 36px;padding: 10px 0;font-size: 12px;">
								<p style="margin: 0;"><span style="width: 10px;height: 10px;border-radius: 5px;background-color: #3371F1;display: inline-block;margin: 0 15px;"></span>修改密码<span style="color: #3371F1;text-decoration: underline;cursor: pointer;margin-left: 25px;" @click="updatePasswordHandle()">去修改</span></p>
								<p style="margin: 0;"><span style="width: 10px;height: 10px;border-radius: 5px;background-color: #3371F1;display: inline-block;margin: 0 15px;"></span>企业信息<span style="color: #3371F1;text-decoration: underline;cursor: pointer;margin-left: 25px;" @click="$router.push({name:'user-qyyh-user'})">{{data.companyCenter.status== 2?'去查看':'去完善'}}</span></p>
							</div>
						</el-row>
					</div>
				</el-col>
				<el-col :span="8" >
					<div style="background-color: #fff;border-radius: 8px;height: 335px;padding:0px 5%;">
						<el-row style="padding-top: 30px;">
						 	<el-col :span="14">
								<span style="font-size: 16px;line-height:0;">结算中心</span>
								<span style="font-size:12px;color:red; padding-left:5px;">支付方式：{{data.bankInfo.payChannel == 1 ? '支付宝' : '招商银行'}}</span>
							</el-col>
							<el-col :span="10" style="display: flex;justify-content: flex-end;">
								<el-button v-if="!data.companyCenter.agreementNo && data.bankInfo.payChannel == 1"
											 type="primary"
											 style="width: 50px;height: 33px;background-color: #469FFB!important;padding: 0;line-height: 26px!important;text-align: center;margin-left: 0px;"
											 @click="handleSign()"
								>签约</el-button>
								<div v-else-if="data.bankInfo.payChannel == 1 && data.companyCenter.agreementNo">
									<el-button
												type="primary"
												style="width: 50px;height: 33px;background-color: #469FFB!important;padding: 0;line-height: 26px!important;text-align: center;margin-left: 0px;"
												@click="handleRecharge(data.bankInfo)"
									>充值</el-button>
								</div>
								<div v-else>
									<el-button
												type="primary"
												style="width: 50px;height: 33px;background-color: #469FFB!important;padding: 0;line-height: 26px!important;text-align: center;margin-left: 0px;"
												@click="handleRecharge(data.bankInfo)"
									>充值</el-button>
								</div>
								
								<el-button type="primary" style="width: 33px;height: 33px;background-color: #469FFB!important;padding: 0;line-height: 26px!important;text-align: center;margin-left: 12px;" icon="el-icon-refresh" @click="getData()"></el-button>
							</el-col>
						</el-row>
						<el-row style="">
							<el-col :span="12">
								<span style="font-size: 12px;line-height: 28px;">待结算</span><br />
								<span class="fontsize" style="font-size: 40px;font-weight:bold;">{{data.settle.pending ? data.settle.pending:0}}</span>
							</el-col>
							<el-col :span="12">
								<span style="font-size: 12px;line-height: 28px;">账户余额</span><br />
								<span class="fontsize" style="font-size: 40px;font-weight:bold;">{{data.settle.balance ? data.settle.balance:0}}</span>
							</el-col>
						</el-row>
						<el-row>
							<div style="background-color: #F9F9F9;line-height: 36px;padding: 10px 0;font-size: 12px;">
								<p style="margin: 0;"><span style="width: 10px;height: 10px;border-radius: 5px;background-color: #3371F1;display: inline-block;margin: 0 15px;"></span>申请结算<span style="color: #3371F1;text-decoration: underline;cursor: pointer;margin-left: 25px;" @click="$router.push({name:'plat-batch-settlement-index'})">去申请</span></p>
								<p style="margin: 0;"><span style="width: 10px;height: 10px;border-radius: 5px;background-color: #3371F1;display: inline-block;margin: 0 15px;"></span>结算单列表<span style="color: #3371F1;text-decoration: underline;cursor: pointer;margin-left: 25px;" @click="$router.push({name:'plat-batch-settlement-list'})">去查看</span></p>
							</div>
						</el-row>
					</div>
				</el-col>
			</el-row>
			<el-row style="margin-top: 25px;" :gutter="20">
				<el-col :span="16">
					<div :style="divStyle">
						<h3 style="margin:0;font-size: 16px;line-height: 76px;">财天下共享经济服务平台业务流程图</h3>
						<img :src="bannerImg" style="margin-top: 32px;width: 100%;;" />
					</div>
				</el-col>
				<el-col :span="8">
					<div style="background-color: #fff;border-radius: 8px;height: 564px;padding: 0 5%;">
						<el-row style="padding-top: 30px;">
							<el-col :span="20">
								<span style="font-size: 16px;">票据中心</span>
							</el-col>
							<el-col :span="4">
								<el-button type="primary" style="width: 33px;height: 33px;background-color: #469FFB!important;padding: 0;line-height: 26px!important;text-align: center;margin-left: 20px;" icon="el-icon-refresh" @click="getData()"></el-button>
							</el-col>
						</el-row>
						<el-row style="padding-top: 30px;">
							<el-col :span="12">
								<span style="font-size: 12px;line-height: 28px;">待开票</span><br />
								<span class="fontsize" style="font-size: 40px;font-weight:bold;">{{data.invoice.wait ? data.invoice.wait:0}}</span>
							</el-col>
							<el-col :span="12">
								<span style="font-size: 12px;line-height: 28px;">开票记录</span><br />
								<span class="fontsize" style="font-size: 40px;font-weight:bold;">{{data.invoice.total ? data.invoice.total:0}}</span>
							</el-col>
						</el-row>
						<el-row>
							<div style="background-color: #F9F9F9;line-height: 36px;padding: 10px 0;font-size: 12px;">
								<p style="margin: 0;"><span style="width: 10px;height: 10px;border-radius: 5px;background-color: #3371F1;display: inline-block;margin: 0 15px;"></span>申请开票<span style="color: #3371F1;text-decoration: underline;cursor: pointer;margin-left: 25px;" @click="$router.push({name:'plat-platinvoicingtasklist'})">去申请</span></p>
								<p style="margin: 0;"><span style="width: 10px;height: 10px;border-radius: 5px;background-color: #3371F1;display: inline-block;margin: 0 15px;"></span>开票记录<span style="color: #3371F1;text-decoration: underline;cursor: pointer;margin-left: 25px;" @click="$router.push({name:'plat-platticketrecordqy'})">去查看</span></p>
							</div>
						</el-row>
						<el-row style="text-align: center;">
							<img :src="bannerBotImg" style="margin-top: 60px;width: 100%;" />
						</el-row>
					</div>
				</el-col>
			</el-row>
		</div> -->
		</el-card>
		<!-- 财务首页 -->
		<el-card v-else-if="role == 'FINANCIAL'" style="background-color: #f1f4f5;" shadow="never" class="aui-card--fill">
			<div class="mod-home" style="padding:0;">
				<el-row :gutter="20">
					<el-col :span="16">
						<el-row :gutter="20">
							<el-col :span="12">
								<div style="background-color: #fff;border-radius: 8px;height: 335px;">
									<el-row style="padding-top: 30px;">
										<el-col :span="20">
											<span style="margin:0px 5%;font-size: 16px;">合同中心</span>
										</el-col>
										<el-col :span="4">
											<el-button type="primary"
												style="width: 33px;height: 33px;background-color: #469FFB!important;padding: 0;line-height: 26px!important;text-align: center;margin-left: 20px;"
												icon="el-icon-refresh" @click="getData()"></el-button>
										</el-col>
									</el-row>
									<el-row style="margin:0px 5%;padding-top: 30px;">
										<el-col :span="12">
											<span style="font-size: 12px;line-height: 28px;">已审核</span><br />
											<span class="fontsize"
												style="font-size: 40px;font-weight:bold;">{{ data.contract.audited ?
													data.contract.audited:0}}</span>
										</el-col>
										<el-col :span="12">
											<span style="font-size: 12px;line-height: 28px;">待审核</span><br />
											<span class="fontsize"
												style="font-size: 40px;font-weight:bold;">{{ data.contract.pending ?
													data.contract.pending:0}}</span>
										</el-col>
									</el-row>
									<el-row style="margin:0px 5%;">
										<div
											style="background-color: #F9F9F9;line-height: 36px;padding: 10px 0;font-size: 12px;">
											<p style="margin: 0;">
												<span
													style="width: 10px;height: 10px;border-radius: 5px;background-color: #3371F1;display: inline-block;margin: 0 15px;"></span>合同列表<span
													style="color: #3371F1;text-decoration: underline;cursor: pointer;margin-left: 25px;"
													@click="$router.push({ name: 'plat-platcontract' })">去查看</span>
											</p>
										</div>
									</el-row>
								</div>
							</el-col>
							<el-col :span="12">
								<div style="background-color: #fff;border-radius: 8px;height: 335px;padding:0px 5%;">
									<el-row style="padding-top: 30px;">
										<el-col :span="20">
											<span style="font-size: 16px;">结算中心</span>
										</el-col>
										<el-col :span="4">
											<el-button type="primary"
												style="width: 33px;height: 33px;background-color: #469FFB!important;padding: 0;line-height: 26px!important;text-align: center;margin-left: 20px;"
												icon="el-icon-refresh" @click="getData()"></el-button>
										</el-col>
									</el-row>
									<el-row style="padding-top: 30px;">
										<el-col>
											<span style="font-size: 12px;line-height: 28px;">待结算</span><br />
											<span class="fontsize"
												style="font-size: 40px;font-weight:bold;">{{ data.settle.pending ?
													data.settle.pending:0}}</span>
										</el-col>
									</el-row>
									<el-row>
										<div
											style="background-color: #F9F9F9;line-height: 36px;padding: 10px 0;font-size: 12px;">
											<p style="margin: 0;"><span
													style="width: 10px;height: 10px;border-radius: 5px;background-color: #3371F1;display: inline-block;margin: 0 15px;"></span>结算单列表<span
													style="color: #3371F1;text-decoration: underline;cursor: pointer;margin-left: 25px;"
													@click="$router.push({ name: 'plat-batch-settlement-list' })">去查看</span>
											</p>
										</div>
									</el-row>
								</div>
							</el-col>
						</el-row>
						<el-row style="margin-top: 25px;">
							<div :style="divStyletwo">
								<h3 style="margin:0;font-size: 16px;line-height: 76px;">财天下共享经济服务平台业务流程图</h3>
								<img :src="bannerImg" style="margin: 12px auto 0px;width: 95%;;" />
							</div>
						</el-row>
					</el-col>
					<el-col :span="8">
						<div style="background-color: #fff;border-radius: 8px;height: 839px;padding: 0 5%;">
							<el-row style="padding-top: 30px;">
								<el-col :span="20">
									<span style="font-size: 16px;">票据中心</span>
								</el-col>
								<el-col :span="4">
									<el-button type="primary"
										style="width: 33px;height: 33px;background-color: #469FFB!important;padding: 0;line-height: 26px!important;text-align: center;margin-left: 20px;"
										icon="el-icon-refresh" @click="getData()"></el-button>
								</el-col>
							</el-row>
							<el-row style="padding-top: 30px;">
								<el-col :span="12">
									<span style="font-size: 12px;line-height: 28px;">待开票</span><br />
									<span class="fontsize" style="font-size: 40px;font-weight:bold;">{{ data.invoice.wait
										? data.invoice.wait:0}}</span>
								</el-col>
								<el-col :span="12">
									<span style="font-size: 12px;line-height: 28px;">开票记录</span><br />
									<span class="fontsize"
										style="font-size: 40px;font-weight:bold;">{{ data.invoice.total ?
											data.invoice.total:0}}</span>
								</el-col>
							</el-row>
							<el-row>
								<div
									style="background-color: #F9F9F9;line-height: 36px;padding: 10px 0;font-size: 12px;">
									<p style="margin: 0;"><span
											style="width: 10px;height: 10px;border-radius: 5px;background-color: #3371F1;display: inline-block;margin: 0 15px;"></span>开票记录<span
											style="color: #3371F1;text-decoration: underline;cursor: pointer;margin-left: 25px;"
											@click="$router.push({ name: 'plat-platticketrecordqy' })">去查看</span></p>
								</div>
							</el-row>

							<el-row style="padding-top: 60px;font-size: 14px;color: #333;font-weight: bold;">
								待开票任务列表
							</el-row>
							<el-row v-for="item in data.invoice.waitTaskList" :key="item.taskCode">
								<el-col :span="12">
									<span style="font-size: 12px;line-height: 28px;">{{ item.taskCode }}</span>
								</el-col>
								<el-col :span="12" style="text-align: right;">
									<span
										style="font-size: 12px;line-height: 28px;text-align: right;">{{ item.publishName }}</span>
								</el-col>
							</el-row>

							<el-row style="text-align: center;">
								<img :src="bannerBotImg" style="margin-top: 60px;width: 100%;" />

							</el-row>
						</div>
					</el-col>
				</el-row>

			</div>
		</el-card>
		<!-- 个人用户首页 -->
		<el-card v-else-if="role == 'PERSON'" style="background-color: #f1f4f5;" shadow="never" class="aui-card--fill">
			<div class="mod-home" style="padding:0;">
				<el-row>
					<el-row :gutter="20">
						<el-col :span="8">
							<div style="background-color: #fff;border-radius: 8px;height: 335px;">
								<el-row style="padding-top: 30px;">
									<el-col :span="20">
										<span style="margin:0px 5%;font-size: 16px;">任务中心</span>
									</el-col>
									<el-col :span="4">
										<el-button type="primary"
											style="width: 33px;height: 33px;background-color: #469FFB!important;padding: 0;line-height: 26px!important;text-align: center;margin-left: 20px;"
											icon="el-icon-refresh" @click="getData()"></el-button>
									</el-col>
								</el-row>
								<el-row style="margin:0px 5%;padding-top: 30px;">
									<el-col :span="8">
										<span style="font-size: 12px;line-height: 28px;">总任务</span><br />
										<span class="fontsize"
											style="font-size: 40px;font-weight:bold;">{{ data.task.total ?
												data.task.total:0}}</span>
									</el-col>
									<el-col push="8" :span="8">
										<span style="font-size: 12px;line-height: 28px;">已接收</span><br />
										<span class="fontsize"
											style="font-size: 40px;font-weight:bold;">{{ data.task.accepted ?
												data.task.accepted:0}}</span>
									</el-col>
								</el-row>
								<el-row style="margin:0px 5%;">
									<div
										style="background-color: #F9F9F9;line-height: 36px;padding: 10px 0;font-size: 12px;">
										<p style="margin: 0;"><span
												style="width: 10px;height: 10px;border-radius: 5px;background-color: #3371F1;display: inline-block;margin: 0 15px;"></span>接受任务<span
												style="color: #3371F1;text-decoration: underline;cursor: pointer;margin-left: 25px;"
												@click="jieshou()">去接受</span></p>
										<p style="margin: 0;"><span
												style="width: 10px;height: 10px;border-radius: 5px;background-color: #3371F1;display: inline-block;margin: 0 15px;"></span>被接受的任务<span
												style="color: #3371F1;text-decoration: underline;cursor: pointer;margin-left: 25px;"
												@click="grchakan()">去查看</span></p>
									</div>
								</el-row>
							</div>
						</el-col>
						<el-col :span="16">
							<div style="background-color: #fff;border-radius: 8px;height: 335px;padding:0px 5%;">
								<el-row style="padding-top: 30px;">
									<el-col :span="22">
										<span style="font-size: 16px;">个人中心</span>
									</el-col>
									<el-col :span="2">
										<el-button type="primary"
											style="width: 33px;height: 33px;background-color: #469FFB!important;padding: 0;line-height: 26px!important;text-align: center;margin-left: 20px;"
											icon="el-icon-refresh" @click="getData()"></el-button>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="8">
										<el-row style="padding-top: 30px;">
											<div style="font-size: 14px;font-weight: bold;color: #343434;line-height: 30px;"
												v-if="data.personCenter && data.personCenter.name != null">
												{{ data.personCenter.name }}，您好({{ infodata.userStatus == 0 ? '未认证' : '已认证' }})
											</div>
											<div style="font-size: 14px;font-weight: bold;color: #343434;line-height: 30px;"
												v-else>您好({{ infodata.userStatus == 0 ? '未认证' : '已认证' }})</div>

											<div
												style="font-size: 12px;font-weight: bold;color: #343434;line-height: 30px;">
												手机号：{{ data.personCenter && data.personCenter.mobile || '' }}</div>
											<div style="font-size: 12px;font-weight: bold;color: #343434;line-height: 30px;"
												v-if="data.personCenter && data.personCenter.email != ''">
												电子邮箱：{{ data.personCenter.email }}</div>
										</el-row>
										<el-row>
											<div
												style="background-color: #F9F9F9;line-height: 36px;padding: 10px 0;font-size: 12px;">
												<p style="margin: 0;"><span
														style="width: 10px;height: 10px;border-radius: 5px;background-color: #3371F1;display: inline-block;margin: 0 15px;"></span>修改密码<span
														style="color: #3371F1;text-decoration: underline;cursor: pointer;margin-left: 25px;"
														@click="updatePasswordHandle()">去修改</span></p>
												<p style="margin: 0;"><span
														style="width: 10px;height: 10px;border-radius: 5px;background-color: #3371F1;display: inline-block;margin: 0 15px;"></span>个人信息<span
														style="color: #3371F1;text-decoration: underline;cursor: pointer;margin-left: 25px;"
														@click="$router.push({ name: 'user-gryh-user' })">{{ data.personCenter
															&& data.personCenter.status == 2 ?'去查看':'去完善'}}</span></p>
											</div>
										</el-row>
									</el-col>
									<el-col :span="6">
										<div style="width: 70%;padding-top: 30px;">
											<img :src='require("../../assets/img/wechat.jpg")' style="width: 100%;" />
										</div>
									</el-col>
									<el-col :span="10">
										<el-row style="padding-top: 30px;">
											<div
												style="font-size: 14px;font-weight: bold;color: #343434;line-height: 30px;">
												证件资料</div>
										</el-row>
										<el-row style="margin-top: 10px;">
											<el-col :span="12">
												<div style="width: 100%;height: 173px;">
													<img :src="data.personCenter && data.personCenter.idFront ? data.personCenter.idFront : ''"
														style="width: 100%;height: 173px;" />
												</div>
											</el-col>
											<el-col :span="12">
												<div style="width: 100%;height: 173px;">
													<img :src="data.personCenter && data.personCenter.idBack ? data.personCenter.idBack : ''"
														style="width: 100%;height: 173px;" />
												</div>
											</el-col>
										</el-row>
									</el-col>
								</el-row>
							</div>
						</el-col>
					</el-row>
					<el-row style="margin-top: 25px;">
						<div :style="divStylethree">
							<h3 style="margin:0;font-size: 16px;line-height: 76px;">财天下共享经济服务平台业务流程图</h3>
							<img :src="bannerImg" style="margin-top: 32px;width: 100%;;" />
						</div>
					</el-row>

				</el-row>

			</div>
		</el-card>
		<!-- 运营管理首页 -->
		<el-card v-else-if="role == 'OPERATE'" style="background-color: #f1f4f5;" shadow="never" class="aui-card--fill">
			<div class="mod-home" style="padding:0;">
				<el-row :gutter="20">
					<el-col :span="8">
						<div style="background-color: #fff;border-radius: 8px;height: 335px;">
							<el-row style="padding-top: 30px;">
								<el-col :span="20">
									<span style="margin:0px 5%;font-size: 16px;">任务中心</span>
								</el-col>
								<el-col :span="4">
									<el-button type="primary"
										style="width: 33px;height: 33px;background-color: #469FFB!important;padding: 0;line-height: 26px!important;text-align: center;margin-left: 20px;"
										icon="el-icon-refresh" @click="getData()"></el-button>
								</el-col>
							</el-row>
							<el-row style="margin:0px 5%;padding-top: 30px;">
								<el-col :span="12">
									<span style="font-size: 12px;line-height: 28px;">总任务</span><br />
									<span class="fontsize" style="font-size: 40px;font-weight:bold;">{{ data.task.total ?
										data.task.total:0}}</span>
								</el-col>
								<el-col :span="12">
									<span style="font-size: 12px;line-height: 28px;">已发布</span><br />
									<span class="fontsize"
										style="font-size: 40px;font-weight:bold;">{{ data.task.published ?
											data.task.published:0}}</span>
								</el-col>
							</el-row>
							<el-row style="margin:0px 5%;">
								<div
									style="background-color: #F9F9F9;line-height: 36px;padding: 10px 0;font-size: 12px;">
									<p style="margin: 0;"><span
											style="width: 10px;height: 10px;border-radius: 5px;background-color: #3371F1;display: inline-block;margin: 0 15px;"></span>分配任务<span
											style="color: #3371F1;text-decoration: underline;cursor: pointer;margin-left: 25px;"
											@click="$router.push({ name: 'plat-plattaskwaitaccept' })"
											class="home_link_hover">去分配</span></p>
									<p style="margin: 0;"><span
											style="width: 10px;height: 10px;border-radius: 5px;background-color: #3371F1;display: inline-block;margin: 0 15px;"></span>任务列表<span
											style="color: #3371F1;text-decoration: underline;cursor: pointer;margin-left: 25px;"
											@click="$router.push({ name: 'plat-plattask' })"
											class="home_link_hover">去查看</span></p>
								</div>
							</el-row>
						</div>
					</el-col>
					<el-col :span="8">
						<div style="background-color: #fff;border-radius: 8px;height: 335px;">
							<el-row style="padding-top: 30px;">
								<el-col :span="20">
									<span style="margin:0px 5%;font-size: 16px;">合同中心</span>
								</el-col>
								<el-col :span="4">
									<el-button type="primary"
										style="width: 33px;height: 33px;background-color: #469FFB!important;padding: 0;line-height: 26px!important;text-align: center;margin-left: 20px;"
										icon="el-icon-refresh" @click="getData()"></el-button>
								</el-col>
							</el-row>
							<el-row style="margin:0px 5%;padding-top: 30px;">
								<el-col :span="12">
									<span style="font-size: 12px;line-height: 28px;">已审核</span><br />
									<span class="fontsize"
										style="font-size: 40px;font-weight:bold;">{{ data.contract.audited ?
											data.contract.audited:0}}</span>
								</el-col>
								<el-col :span="12">
									<span style="font-size: 12px;line-height: 28px;">待审核</span><br />
									<span class="fontsize"
										style="font-size: 40px;font-weight:bold;">{{ data.contract.pending ?
											data.contract.pending:0}}</span>
								</el-col>
							</el-row>
							<el-row>
								<div
									style="margin:0px 5%;background-color: #F9F9F9;line-height: 36px;padding: 10px 0;font-size: 12px;">
									<p style="margin: 0;">
										<span
											style="width: 10px;height: 10px;border-radius: 5px;background-color: #3371F1;display: inline-block;margin: 0 15px;"></span>新增合同<span
											style="color: #3371F1;text-decoration: underline;cursor: pointer;margin-left: 25px;"
											@click="xinzeng()" class="home_link_hover">去新增</span>
									</p>
									<p style="margin: 0;">
										<span
											style="width: 10px;height: 10px;border-radius: 5px;background-color: #3371F1;display: inline-block;margin: 0 15px;"></span>合同列表<span
											style="color: #3371F1;text-decoration: underline;cursor: pointer;margin-left: 25px;"
											@click="$router.push({ name: 'plat-platcontract' })"
											class="home_link_hover">去查看</span>
									</p>
								</div>
							</el-row>
						</div>
					</el-col>
					<el-col :span="8">
						<div style="background-color: #fff;border-radius: 8px;height: 335px;padding:0px 5%;">
							<el-row style="padding-top: 30px;">
								<el-col :span="20">
									<span style="font-size: 16px;">结算中心</span>
								</el-col>
								<el-col :span="4">
									<el-button type="primary"
										style="width: 33px;height: 33px;background-color: #469FFB!important;padding: 0;line-height: 26px!important;text-align: center;margin-left: 20px;"
										icon="el-icon-refresh" @click="getData()"></el-button>
								</el-col>
							</el-row>
							<el-row style="padding-top: 30px;">
								<el-col :span="12">
									<span style="font-size: 12px;line-height: 28px;">待结算</span><br />
									<span class="fontsize"
										style="font-size: 40px;font-weight:bold;">{{ data.settle.pending ?
											data.settle.pending:0}}</span>
								</el-col>
								<el-col :span="12">
									<span style="font-size: 12px;line-height: 28px;">账户余额</span><br />
									<span class="fontsize" :title='data.settle.balance'
										style="font-size: 40px;font-weight:bold;">{{ data.settle.balance ?
											moneyUtils(data.settle.balance) :0}}</span>
								</el-col>
							</el-row>
							<el-row>
								<div
									style="background-color: #F9F9F9;line-height: 36px;padding: 10px 0;font-size: 12px;">
									<p style="margin: 0;"><span
											style="width: 10px;height: 10px;border-radius: 5px;background-color: #3371F1;display: inline-block;margin: 0 15px;"></span>申请结算<span
											style="color: #3371F1;text-decoration: underline;cursor: pointer;margin-left: 25px;"
											@click="$router.push({ name: 'plat-batch-settlement-index' })"
											class="home_link_hover">去申请</span></p>
									<p style="margin: 0;"><span
											style="width: 10px;height: 10px;border-radius: 5px;background-color: #3371F1;display: inline-block;margin: 0 15px;"></span>结算单列表<span
											style="color: #3371F1;text-decoration: underline;cursor: pointer;margin-left: 25px;"
											@click="$router.push({ name: 'plat-batch-settlement-list' })"
											class="home_link_hover">去查看</span></p>
								</div>
							</el-row>
						</div>
					</el-col>
				</el-row>
				<el-row style="margin-top: 25px;" :gutter="20">
					<el-col :span="16">
						<div :style="divStyle">
							<h3 style="margin:0;font-size: 16px;line-height: 76px;">财天下共享经济服务平台业务流程图</h3>
							<img :src="bannerImg" style="width: 100%;;" />
						</div>
					</el-col>
					<el-col :span="8">
						<div style="background-color: #fff;border-radius: 8px;height: 564px;padding: 0 5%;">
							<el-row style="padding-top: 30px;">
								<el-col :span="20">
									<span style="font-size: 16px;">票据中心</span>
								</el-col>
								<el-col :span="4">
									<el-button type="primary"
										style="width: 33px;height: 33px;background-color: #469FFB!important;padding: 0;line-height: 26px!important;text-align: center;margin-left: 20px;"
										icon="el-icon-refresh" @click="getData()"></el-button>
								</el-col>
							</el-row>
							<el-row style="padding-top: 30px;">
								<el-col :span="12">
									<span style="font-size: 12px;line-height: 28px;">待开票</span><br />
									<span class="fontsize" style="font-size: 40px;font-weight:bold;">{{ data.invoice.wait
										? data.invoice.wait:0}}</span>
								</el-col>
								<el-col :span="12">
									<span style="font-size: 12px;line-height: 28px;">开票记录</span><br />
									<span class="fontsize"
										style="font-size: 40px;font-weight:bold;">{{ data.invoice.total ?
											data.invoice.total:0}}</span>
								</el-col>
							</el-row>
							<el-row>
								<div
									style="background-color: #F9F9F9;line-height: 36px;padding: 10px 0;font-size: 12px;">
									<p style="margin: 0;"><span
											style="width: 10px;height: 10px;border-radius: 5px;background-color: #3371F1;display: inline-block;margin: 0 15px;"></span>申请开票<span
											style="color: #3371F1;text-decoration: underline;cursor: pointer;margin-left: 25px;"
											@click="$router.push({ name: 'plat-platinvoicingtasklist' })"
											class="home_link_hover">去申请</span></p>
									<p style="margin: 0;"><span
											style="width: 10px;height: 10px;border-radius: 5px;background-color: #3371F1;display: inline-block;margin: 0 15px;"></span>开票记录<span
											style="color: #3371F1;text-decoration: underline;cursor: pointer;margin-left: 25px;"
											@click="$router.push({ name: 'plat-platticketrecordqy' })"
											class="home_link_hover">去查看</span></p>
								</div>
							</el-row>
							<el-row style="text-align: center;">
								<img :src="bannerBotImg" style="margin-top: 60px;width: 100%;" />
							</el-row>
						</div>
					</el-col>
				</el-row>
				<!-- <h2 class="h2Title" style="margin-top:30px; padding-left:10px;">
				<img src="../../assets/img/card3.png" alt="">
				数据统计
			</h2> -->
				<el-row :gutter="20" type="flex" justify="center" style="margin-top:35px;">
					<el-col :span="12">
						<el-card class="box-card box-card3">
							<div class="cardCon cardCon3" style="flex-direction: column;">
								<el-row style="width: 95%;">
									<el-col :span="20">
										<span style="font-size: 16px;">今日快报</span>
									</el-col>
									<el-col :span="4" style="display: flex;justify-content: flex-end;">
										<el-button type="primary"
											style="width: 33px;height: 33px;background-color: #469FFB!important;padding: 0;line-height: 26px!important;text-align: center;margin-left: 20px;"
											icon="el-icon-refresh" @click="getData()"></el-button>
									</el-col>
								</el-row>
								<div
									style="display: flex;width:100%;align-items: center;justify-content: space-around;">
									<dl>
										<dt>
											<img src="../../assets/img/rw.png" alt="" style="width: 40px;height: 40px;">
										</dt>
										<dd>
											<span>{{ data.todayReport && data.todayReport.newTaskCount ? data.todayReport.newTaskCount : 0 }}</span>
											<p>新增任务(个)</p>
										</dd>
									</dl>
									<dl>
										<dt>
											<img src="../../assets/img/card3_2.png" alt="">
										</dt>
										<dd>
											<span>{{ data.todayReport && data.todayReport.settlementAmount ? data.todayReport.settlementAmount : 0 }}</span>
											<p>结算金额(元)</p>
										</dd>
									</dl>
								</div>
								<div
									style="display: flex;width:100%;align-items: center;justify-content: space-around;">
									<dl>
										<dt>
											<img src="../../assets/img/card3_3.png" alt="">
										</dt>
										<dd>
											<span>{{ data.todayReport && data.todayReport.invoiceCount ? data.todayReport.invoiceCount : 0 }}</span>
											<p>开票数量(张)</p>
										</dd>
									</dl>
									<dl>
										<dt>
											<img src="../../assets/img/card3_1.png" alt="">
										</dt>
										<dd>
											<span>{{ data.todayReport && data.todayReport.newUserCount ? data.todayReport.newUserCount : 0 }}</span>
											<p>新增用户(个)</p>
										</dd>
									</dl>
								</div>
							</div>
						</el-card>
					</el-col>
					<el-col :span="12">
						<el-card class="box-card box-card3">
							
							<div class="cardCon cardCon3" style="flex-direction: column;">
								<el-row style="width: 95%;">
									<el-col :span="20">
										<span style="font-size: 16px;">待办速览</span>
									</el-col>
									<el-col :span="4" style="display: flex;justify-content: flex-end;">
										<el-button type="primary"
											style="width: 33px;height: 33px;background-color: #469FFB!important;padding: 0;line-height: 26px!important;text-align: center;margin-left: 20px;"
											icon="el-icon-refresh" @click="getData()"></el-button>
									</el-col>
								</el-row>
								<div
									style="display: flex;width:100%;align-items: center;justify-content: space-around;padding-bottom:50px">
								<dl>
									<dt>
										<img src="../../assets/img/ht.png" alt="" style="width: 40px;height: 40px;">
									</dt>
									<dd>
										<span>{{ data.todoSnapshot && data.todoSnapshot.pendingContractCount ? data.todoSnapshot.pendingContractCount : 0 }}</span>
										<p>待审核合同(份)</p>
									</dd>
								</dl>
								<dl>
									<dt>
										<img src="../../assets/img/js.png" alt="" style="width: 40px;height: 40px;">
									</dt>
									<dd>
										<span>{{ data.todoSnapshot && data.todoSnapshot.pendingSettlementCount ? data.todoSnapshot.pendingSettlementCount : 0 }}</span>
										<p>待处理结算(笔)</p>
									</dd>
								</dl>
								<dl>
									<dt>
										<img src="../../assets/img/kp.png" alt="" style="width: 40px;height: 40px;">
									</dt>
									<dd>
										<span>{{ data.todoSnapshot && data.todoSnapshot.pendingInvoiceCount ? data.todoSnapshot.pendingInvoiceCount : 0 }}</span>
										<p>待审核开票(单)</p>
									</dd>
								</dl>
								</div>
							</div>
						</el-card>
					</el-col>
				</el-row>
			</div>
		</el-card>
		<!-- 监管员 -->
		<el-card v-else-if="role == 'SUPERVISION'" style="background-color: #f1f4f5;" shadow="never"
			class="aui-card--fill">
			<div class="mod-home" style="padding:0;">
				<el-row :gutter="20">
					<el-col :span="8">
						<div style="background-color: #fff;border-radius: 8px;height: 335px;">
							<el-row style="padding-top: 30px;">
								<el-col :span="20">
									<span style="margin:0px 5%;font-size: 16px;">任务中心</span>
								</el-col>
								<el-col :span="4">
									<el-button type="primary"
										style="width: 33px;height: 33px;background-color: #469FFB!important;padding: 0;line-height: 26px!important;text-align: center;margin-left: 20px;"
										icon="el-icon-refresh" @click="getData()"></el-button>
								</el-col>
							</el-row>
							<el-row style="margin:0px 5%;padding-top: 30px;">
								<el-col :span="12">
									<span style="font-size: 12px;line-height: 28px;">总任务</span><br />
									<span class="fontsize" style="font-size: 40px;font-weight:bold;">{{ data.task.total ?
										data.task.total:0}}</span>
								</el-col>
								<el-col :span="12">
									<span style="font-size: 12px;line-height: 28px;">已发布</span><br />
									<span class="fontsize"
										style="font-size: 40px;font-weight:bold;">{{ data.task.published ?
											data.task.published:0}}</span>
								</el-col>
							</el-row>
							<el-row style="margin:0px 5%;">
								<div
									style="background-color: #F9F9F9;line-height: 36px;padding: 10px 0;font-size: 12px;">
									<p style="margin: 0;"><span
											style="width: 10px;height: 10px;border-radius: 5px;background-color: #3371F1;display: inline-block;margin: 0 15px;"></span>任务列表<span
											style="color: #3371F1;text-decoration: underline;cursor: pointer;margin-left: 25px;"
											@click="$router.push({ name: 'plat-plattask' })"
											class="home_link_hover">去查看</span></p>
								</div>
							</el-row>
						</div>
					</el-col>
					<el-col :span="8">
						<div style="background-color: #fff;border-radius: 8px;height: 335px;">
							<el-row style="padding-top: 30px;">
								<el-col :span="20">
									<span style="margin:0px 5%;font-size: 16px;">合同中心</span>
								</el-col>
								<el-col :span="4">
									<el-button type="primary"
										style="width: 33px;height: 33px;background-color: #469FFB!important;padding: 0;line-height: 26px!important;text-align: center;margin-left: 20px;"
										icon="el-icon-refresh" @click="getData()"></el-button>
								</el-col>
							</el-row>
							<el-row style="margin:0px 5%;padding-top: 30px;">
								<el-col :span="12">
									<span style="font-size: 12px;line-height: 28px;">已审核</span><br />
									<span class="fontsize"
										style="font-size: 40px;font-weight:bold;">{{ data.contract.audited ?
											data.contract.audited:0}}</span>
								</el-col>
								<el-col :span="12">
									<span style="font-size: 12px;line-height: 28px;">待审核</span><br />
									<span class="fontsize"
										style="font-size: 40px;font-weight:bold;">{{ data.contract.pending ?
											data.contract.pending:0}}</span>
								</el-col>
							</el-row>
							<el-row>
								<div
									style="margin:0px 5%;background-color: #F9F9F9;line-height: 36px;padding: 10px 0;font-size: 12px;">

									<p style="margin: 0;">
										<span
											style="width: 10px;height: 10px;border-radius: 5px;background-color: #3371F1;display: inline-block;margin: 0 15px;"></span>合同列表<span
											style="color: #3371F1;text-decoration: underline;cursor: pointer;margin-left: 25px;"
											@click="$router.push({ name: 'plat-platcontract' })"
											class="home_link_hover">去查看</span>
									</p>
								</div>
							</el-row>
						</div>
					</el-col>
					<el-col :span="8">
						<div style="background-color: #fff;border-radius: 8px;height: 335px;padding:0px 5%;">
							<el-row style="padding-top: 30px;">
								<el-col :span="20">
									<span style="font-size: 16px;">结算中心</span>
								</el-col>
								<el-col :span="4">
									<el-button type="primary"
										style="width: 33px;height: 33px;background-color: #469FFB!important;padding: 0;line-height: 26px!important;text-align: center;margin-left: 20px;"
										icon="el-icon-refresh" @click="getData()"></el-button>
								</el-col>
							</el-row>
							<el-row style="padding-top: 30px;">
								<el-col :span="12">
									<span style="font-size: 12px;line-height: 28px;">待结算</span><br />
									<span class="fontsize"
										style="font-size: 40px;font-weight:bold;">{{ data.settle.pending ?
											data.settle.pending:0}}</span>
								</el-col>
								<el-col :span="12">
									<span style="font-size: 12px;line-height: 28px;">账户余额</span><br />
									<span class="fontsize" :title='data.settle.balance'
										style="font-size: 40px;font-weight:bold;">{{ data.settle.balance ?
											moneyUtils(data.settle.balance):0}}</span>
								</el-col>
							</el-row>
							<el-row>
								<div
									style="background-color: #F9F9F9;line-height: 36px;padding: 10px 0;font-size: 12px;">

									<p style="margin: 0;"><span
											style="width: 10px;height: 10px;border-radius: 5px;background-color: #3371F1;display: inline-block;margin: 0 15px;"></span>结算单列表<span
											style="color: #3371F1;text-decoration: underline;cursor: pointer;margin-left: 25px;"
											@click="$router.push({ name: 'plat-batch-settlement-list' })"
											class="home_link_hover">去查看</span></p>
								</div>
							</el-row>
						</div>
					</el-col>
				</el-row>
				<el-row style="margin-top: 25px;" :gutter="20">
					<el-col :span="16">
						<div :style="divStyle">
							<h3 style="margin:0;font-size: 16px;line-height: 76px;">财天下共享经济服务平台业务流程图</h3>
							<img :src="bannerImg" style="margin-top: 32px;width: 100%;;" />
						</div>
					</el-col>
					<el-col :span="8">
						<div style="background-color: #fff;border-radius: 8px;height: 564px;padding: 0 5%;">
							<el-row style="padding-top: 30px;">
								<el-col :span="20">
									<span style="font-size: 16px;">票据中心</span>
								</el-col>
								<el-col :span="4">
									<el-button type="primary"
										style="width: 33px;height: 33px;background-color: #469FFB!important;padding: 0;line-height: 26px!important;text-align: center;margin-left: 20px;"
										icon="el-icon-refresh" @click="getData()"></el-button>
								</el-col>
							</el-row>
							<el-row style="padding-top: 30px;">
								<el-col :span="12">
									<span style="font-size: 12px;line-height: 28px;">待开票</span><br />
									<span class="fontsize" style="font-size: 40px;font-weight:bold;">{{ data.invoice.wait
										? data.invoice.wait:0}}</span>
								</el-col>
								<el-col :span="12">
									<span style="font-size: 12px;line-height: 28px;">开票记录</span><br />
									<span class="fontsize"
										style="font-size: 40px;font-weight:bold;">{{ data.invoice.total ?
											data.invoice.total:0}}</span>
								</el-col>
							</el-row>
							<el-row>
								<div
									style="background-color: #F9F9F9;line-height: 36px;padding: 10px 0;font-size: 12px;">

									<p style="margin: 0;"><span
											style="width: 10px;height: 10px;border-radius: 5px;background-color: #3371F1;display: inline-block;margin: 0 15px;"></span>开票记录<span
											style="color: #3371F1;text-decoration: underline;cursor: pointer;margin-left: 25px;"
											@click="$router.push({ name: 'plat-platticketrecordqy' })"
											class="home_link_hover">去查看</span></p>
								</div>
							</el-row>
							<el-row style="text-align: center;">
								<img :src="bannerBotImg" style="margin-top: 60px;width: 100%;" />
							</el-row>
						</div>
					</el-col>
				</el-row>
			</div>
		</el-card>

		<div style="width:300px;margin:0 auto; padding:20px 0;">
			<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010202009055"
				style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
				<img :src='require("../../assets/img/icon.png")' style="float:left;" />
				<p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">京公网安备 <span
						style="text-decoration: underline;">11010202009055</span>号</p>
			</a>
		</div>
		<!--汇款信息弹框-->
		<el-dialog title="汇款信息" v-if="dialogRecharge" :visible.sync="dialogRecharge" :before-close="rechargeDiaClose"
			width="500px" class="dialogStyle">
			<div style="padding-bottom:50px;">
				<el-form style="margin: 0px 0px 0px 26px;" label-width="82px" :model="form" label-position="left">
					<el-form-item class="formItem" label="税源地：">
						<el-select class="select-tax-source" v-model="form.bodyId" @change="rechargeChangeTaxSource">
							<el-option v-for="item in data.bankInfos" :key="item.bodyId" :label="item.abbreviation"
								:value="item.bodyId">
							</el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<!-- 支付宝签约 -->
				<div v-if="form.payeeBankName == '支付宝' && data.personCenter.needSignBodyIds.indexOf(form.bodyId) != -1">
					<el-button style="width:80%;margin:30px auto 0;display:block;" type="primary"
						@click="handleSign()">去签约</el-button>
				</div>
				<!-- 支付宝充值 -->
				<template
					v-else-if="form.payeeBankName == '支付宝' && data.personCenter.needSignBodyIds.indexOf(form.bodyId) == -1">
					<el-form style="margin: 0px 0px 0px 26px;" label-width="82px" :model="form" label-position="left">
						<el-form-item class="formItem" label="充值金额:">
							<el-input style="width:270px;" v-model="zfbMoney" placeholder="充值金额"></el-input>
						</el-form-item>
					</el-form>
					<el-button style="width:80%;margin:0 auto;display:block;" type="primary"
						@click="handleZfbPayment()">确认</el-button>
				</template>
				<!-- 银行已开户 -->
				<div class="dialog-main" v-else-if="form.payeeBankName != '支付宝' && form.childAcctNo">
					<el-form style="margin: 0px 0px 0px 26px;" label-width="82px" :model="form" label-position="left">
						<el-form-item class="formItem" label="付款账号：">
							<el-input readonly ref="payment" v-model="form.payeeAccountTitle"></el-input>
							<span class="copy" @click="handleCopy(1)">复制</span>
						</el-form-item>
						<el-form-item class="formItem" label="账户名称：">
							<el-input readonly ref="accountName" v-model="form.payeeAccountTitle"></el-input>
							<span class="copy" @click="handleCopy(2)">复制</span>
						</el-form-item>
						<el-form-item class="formItem" label="开户银行：">
							<el-input readonly ref="bank" v-model="form.payeeBankName"></el-input>
							<span class="copy" @click="handleCopy(3)">复制</span>
						</el-form-item>
						<el-form-item class="formItem" label="专属账户：">
							<el-input readonly ref="exclusiveAccount" v-model="form.payeeBankAccount"></el-input>
							<span class="copy" @click="handleCopy(4)">复制</span>
						</el-form-item>
						<el-form-item class="formItem" label="用途：">
							<el-input readonly ref="channel" v-model="form.purpose"></el-input>
							<span class="copy" @click="handleCopy(5)">复制</span>
						</el-form-item>
					</el-form>
					<p style="color: red; margin-top: 0px;margin-left: 24px;margin-bottom: 15px;">
						汇款时请务必备注充值通道，以便充值到您预期的通道</p>
					<div style="border-top: 1px solid #D2D2D2;padding: 0 20px">
						<h6 style="line-height: 30px;margin: 0;">温馨提示：</h6>
						<p
							style="margin: 0;text-indent: 30px;font-size:14px;color:#333;line-height: 20px;padding-bottom:10px;">
							请线下汇款，汇款时间：<span style="color: red">23:30 — 次日凌晨 1:00</span> 不支持汇款，其他时间段均可汇款，汇款时间不区分工作日和周末。
						</p>
					</div>
				</div>
				<!-- 银行未开户 -->
				<div v-else class="text-center childAcctNo">您的账户尚未开通，请联系运营人员</div>
			</div>
			<!-- <div slot="footer" style="text-align: center">
					<el-button type="primary" size="mini"  @click="rechargeDiaClose" >知道了</el-button>
			 </div> -->
		</el-dialog>
		<el-dialog :modal-append-to-body="false" title="请选择" width="500px" custom-class="dialogBg" :show-close="false"
			top="264px" center :visible="dialogVisible">
			<el-radio-group style="line-height: 50px;padding-left: 40px;" v-model="radio">
				<el-radio v-for="item in roles" :key="item" :label="item">{{ rolename[item] }}</el-radio><br />
			</el-radio-group>
			<div slot="footer" style="padding-bottom: 30px;" class="dialog-footer">
				<el-button v-no-more-click @click="selectRole"
					style="width: 400px;height: 80px;line-height: 80px;border-radius: 40px!important;font-size: 20px;box-shadow: 0px 6px 9px 0px rgba(25, 56, 178, 0.32);"
					type="primary">确定</el-button>
			</div>
		</el-dialog>

		<!-- 弹窗, 修改密码 -->
		<update-password v-if="updatePasswordVisible" ref="updatePassword"></update-password>

		<!-- 确认风控表 -->
		<el-dialog :visible.sync="fkbVisable" width="1200px" :show-close="false" :before-close="handleClose">
			<h2 slot="title" class="fkbTitle">风控表信息确认<span>(以下为风控表全部信息，请认真查阅并确认，如有疑问请联系运营人员)</span></h2>
			<fkbInfo ref="fkbInfo" v-if="infodata.id" :userId="infodata.id" :fkbShow="true"></fkbInfo>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="fkbClick()" :disabled="fkbtime ? true : false"
					style="display: block;margin:0 auto;">确 定 {{ fkbtime }}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import QRCode from "qrcodejs2";
import { addDynamicRoute } from '@/router'
import Cookies from 'js-cookie'
import UpdatePassword from '../main-navbar-update-password'
import { clearLoginInfo } from '@/utils';
import fkbInfo from './user/edit-qyyh-user-qyfkb.vue'
import DataUtils from '@/utils/DataUtils'
import { Loading } from 'element-ui';
export default {
	data() {
		return {
			fkbtime: 10,
			fkbVisable: false,
			qrCodeStr: '',
			zfbMoney: '',//支付宝充值金额
			dialogRecharge: false,               //充值信息弹框状态
			form: {
				bodyId: "",
				childAcctNo: "",
				payeeAccountTitle: "", payeeBankAccount: "",
				payeeBankName: "",
				purpose: "银行卡通道充值",
			},

			data: {    //预置对象，防止报错
				companyCenter: {},
				bankInfos: [],
				contract: {},
				invoice: {},
				personCenter: null,
				settle: {},
				task: {},
				transactions: []
			},
			updatePasswordVisible: false,
			dialogVisible: false,
			bannerImg: require("../../assets/img/banner.png"),
			bannerBotImg: require("../../assets/img/bannerBot.png"),
			divStyle: {
				height: "564px",
				borderRadius: '8px',
				// backgroundImage: 'url(' + require("../../assets/img/bannerBg.png") + ')',
				backgroundColor: 'white',
				backgroundRepeat: 'no-repeat',
				backgroundSize: '100% 100%',
				padding: '0 5%',
				overflow: 'hidden'
			},
			divStyletwo: {
				height: "488px",
				borderRadius: '8px',
				backgroundImage: 'url(' + require("../../assets/img/bannerBg.png") + ')',
				backgroundRepeat: 'no-repeat',
				backgroundSize: '100% 100%',
				padding: '0 5%',
			},
			divStylethree: {
				height: "700px",
				borderRadius: '8px',
				backgroundImage: 'url(' + require("../../assets/img/bannerBg.png") + ')',
				backgroundRepeat: 'no-repeat',
				backgroundSize: '100% 100%',
				padding: '0 5%',
			},
			role: "UNKNOWN",
			rolename: [],
			radio: 1,
			roles: [],
			infodata: [],
			transaction: {},
			refreshIcon: '',
			allToBePaid: 0
		}
	},
	components: {
		UpdatePassword, fkbInfo
	},
	created() {
		this.rolename['PERSON'] = '个人用户'
		this.rolename['COMPANY'] = '企业用户'
		this.rolename['FINANCIAL'] = '财务人员'
		this.rolename['SUPERVISION'] = '监管员'
		this.rolename['OPERATE'] = '运营人员'
		this.$http
			.get('/sys/user/info')
			.then(({ data: res }) => {
				if (res.code !== 0) {
					return this.$message.error(res.msg)
				}
				this.infodata = res.data
				console.log(res.data)
				Cookies.set('userInfoId', res.data.id)
				if (this.infodata.userType == 'none') {
					this.roles.push('PERSON')
					this.roles.push('COMPANY')
					this.dialogVisible = true
				} else {
					// 获取用户的权限
					this.$http.get(`/sys/user/myRole`).then(({ data: res }) => {
						if (res.code !== 0) {
							return this.$message.error(res.msg)
						}
						this.roles = res.data
						if (res.data.length == 0) {
							this.roles.push('PERSON')
							this.roles.push('COMPANY')
							this.infodata.userType = 'none'
							this.dialogVisible = true
						} else if (res.data.length == 1) {
							this.role = res.data[0]
							Cookies.set('admin_role', this.role)
							this.dialogVisible = false
							let role = this.role
							this.$http.get(`/sys/dashboard/data?role=` + role).then(({ data: res }) => {
								if (res.code !== 0) {
									return this.$message.error(res.msg)
								}
								this.data = res.data
								console.log(this.data)
								// 除了湖南税源地 调用二维码接口
								// if(this.data && this.data.bankInfos && this.data.bankInfos[0] && this.data.bankInfos[0].bodyId != '1453241566079012865'){
								// 	this.$http.get(`/sys/dashboard/getQrcode?bodyId=${this.data.bankInfos[0].bodyId}`).then(({data:res}) => {
								// 		console.log(res)
								// 	})
								// }
								this.transaction = Object.assign({}, res.data.transactions ? res.data.transactions[0] : {});
								this.allToBePaid = 0
								if (res.data.transactions) {
									res.data.transactions.map((item) => {
										this.allToBePaid += item.toBePaid
									})
								}
								localStorage.setItem('homeUserInfoId', res.data.companyCenter ? res.data.companyCenter.id : '')
								// this.qrCodeStr = this.data.bankInfos[0].signUrl;
								// this.$nextTick(() => {
								// 	this.qrCode();
								// })
							}).catch(() => { })

							console.log(this.data.bankInfos)
							//   判断企业用户是否首次登录
							console.log(this.infodata.isConfirmInfo)
							if (this.role == 'COMPANY' && this.infodata.isConfirmInfo == 0) {
								// if(this.role == 'COMPANY' && (this.infodata.bodyIds != '1453241566079012865' || this.infodata.bodyIds != '2043514323391295490') && this.infodata.isConfirmInfo == 0){
								this.fkbVisable = true;
								var timer = null;
								timer = setInterval(() => {
									if (this.fkbtime <= 0 || this.fkbtime == '') {
										this.fkbtime = ''
										clearInterval(timer)
									} else {
										this.fkbtime--
									}
								}, 1000)

							}
						} else {
							this.dialogVisible = true
						}
					}).catch(() => { })
				}
			})
			.catch(() => { })
	},
	methods: {
		moneyUtils(data) {
			return DataUtils.moneyUtils(data)
		},
		handleClose() {

		},
		fkbClick() {
			this.$http.post(`/sys/plat/info/ca/confirmInfo?id=${this.infodata.id}`).then(({ data: res }) => {
				if (res.code == 0) {
					this.fkbVisable = false;
				}
			})
		},
		downloadByBlob(url, name) {
			let image = new Image()
			image.setAttribute('crossOrigin', 'anonymous')
			image.src = url
			image.onload = () => {
				let canvas = document.createElement('canvas')
				canvas.width = image.width
				canvas.height = image.height
				let ctx = canvas.getContext('2d')
				ctx.drawImage(image, 0, 0, image.width, image.height)
				canvas.toBlob((blob) => {
					let url = URL.createObjectURL(blob)
					this.download(url, name)
					// 用完释放URL对象
					URL.revokeObjectURL(url)
				})
			}
		},
		download(href, name) {
			let eleLink = document.createElement('a')
			eleLink.download = name
			eleLink.href = href
			eleLink.click()
			eleLink.remove()
		},
		parseQuery: function (url) {
			var queryObj = {};
			var reg = /[?&]([^=&#]+)=([^&#]*)/g;
			var querys = url.match(reg);
			if (querys) {
				for (var i in querys) {
					var query = querys[i].split('=');
					var key = query[0].substr(1),
						value = query[1];
					queryObj[key] ? queryObj[key] = [].concat(queryObj[key], value) : queryObj[key] = value;
				}
			}
			return queryObj;
		},
		qrCode() {
			let _this = this;
			let qrCOde = new QRCode('qrcode', {
				width: 150,
				height: 150,
				text: _this.qrCodeStr
			})
		},
		fnPayPage() {
			localStorage.setItem('activeIndex', 2);
			this.$router.push({ name: 'plat-batch-settlement-list' })
		},
		//   支付宝充值
		async handleZfbPayment() {
			const res = await this.$http.post('/sys/spdb/pagePay', {
				userId: this.infodata.id,
				money: this.zfbMoney,
				bodyId: this.form.bodyId
			})
			if (res.data.code == 0) {
				window.open(res.data.data, '_self')
			} else {
				this.$message.error(res.data.msg)
			}
		},
		//    设置银行卡号,每四位添加一个空格
		setNum(data) {
			console.log(data)
			var res = ''
			res = data ? data.replace(/\s/g, '').replace(/[^\d]/g, '').replace(/(\d{4})(?=\d)/g,
				'$1 ') : ''
			this.$set(this.form, 'payeeBankAccount', res)
		},
		//   签约
		async handleSign() {
			const res = await this.$http.get(`/sys/spdb/agreementPageSign?userId=${this.infodata.id}&bodyId=${this.form.bodyId}`, {});
			if (res.data.code == 0) {
				window.open(res.data.data, '_self')
			} else {
				this.$message.error(res.data.msg)
			}
		},
		//		    充值
		handleRecharge() {
			const item = this.data.bankInfos[0]
			if (item) {
				this.form.agreementNo = item.agreementNo;
				this.form.bodyId = item.bodyId;
				this.form.payeeBankName = item.payeeBankName;
				if (item.payeeBankName != '支付宝') {
					this.form.childAcctNo = item.childAcctNo;
					this.form.payeeAccountTitle = item.payeeAccountTitle;
					this.setNum(this.form.payeeBankAccount = item.childAcctNo);
				}
				this.dialogRecharge = true;
			} else {
				this.$message.error('您的账户尚未开通，请联系运营人员')
			}

		},
		rechargeDiaClose() {
			this.dialogRecharge = false;
		},
		//充值切换税源地
		rechargeChangeTaxSource(value) {
			let item = this.data.bankInfos.find(item => {
				return item.bodyId == value;
			})
			this.form.payeeBankName = item.payeeBankName;
			this.form.agreementNo = item.agreementNo;
			if (item.payeeBankName != '支付宝') {
				this.form.childAcctNo = item.childAcctNo;
				this.form.payeeAccountTitle = item.payeeAccountTitle;
				this.setNum(this.form.payeeBankAccount = item.payeeBankAccount + item.childAcctNo);
			}
			this.dialogRecharge = true;
		},
		//数据概况切换税源地
		changeTaxSource(value) {
			let item = this.data.transactions.find(item => {
				return item.bodyId == value;
			})

			this.transaction = Object.assign({}, item ? item : {});
		},
		//企业用户刷新余额
		refreshbalance() {
			this.refreshIcon = 'refreshing'
			let timer = setTimeout(() => {
				this.refreshIcon = ''
				clearTimeout(timer)
			}, 500)
			this.$http.get('/sys/dashboard/refreshBalance?bodyId=' + this.transaction.bodyId)
				.then(({ data: res }) => {
					if (res.code !== 0) {
						return this.$message.error(res.msg)
					}
					this.transaction.balance = res.data
				}).catch(() => { })
		},
		//	  复制功能
		handleCopy(type) {
			if (type == 1) this.$refs.payment.select(); document.execCommand("Copy");
			if (type == 2) this.$refs.accountName.select(); document.execCommand("Copy");
			if (type == 3) this.$refs.bank.select(); document.execCommand("Copy");
			if (type == 4) this.$refs.exclusiveAccount.select(); document.execCommand("Copy");
			if (type == 5) this.$refs.channel.select(); document.execCommand("Copy");
		},
		selectRole() {
			console.log(this.radio)
			// 提交选择结果
			// ----
			// 提交完成
			this.role = this.radio
			Cookies.set('admin_role', this.role)
			// this.role = 'COMPANY';
			let role = this.role

			// 设置用户的类型
			if (this.infodata.userType == 'none') {
				let usertype = this.role == 'PERSON' ? 'gryh' : 'qyyh'
				this.$http.post('/sys/user/chooseType', { userType: usertype }, {
					headers: {
						'content-type': 'application/x-www-form-urlencoded'
					}
				}).then(({ data: res }) => {
					if (res.code !== 0) {
						return this.$message.error(res.msg)
					}
					this.logoutHandle()
				}).catch(() => { })
			} else {
				this.$http.get(`/sys/dashboard/data?role=` + role).then(({ data: res }) => {
					if (res.code !== 0) {
						return this.$message.error(res.msg)
					}
					this.data = res.data
				}).catch(() => { })
				this.dialogVisible = false
			}
		},
		getData() {
			let loadingInstance = Loading.service({})
			setTimeout(function () {
				loadingInstance.close()
			}, 500)
			this.$http.get(`/sys/dashboard/data?role=` + this.role).then(({ data: res }) => {
				if (res.code !== 0) {
					return this.$message.error(res.msg)
				}
				this.data = res.data
			}).catch(() => { })
			this.$http
				.get('/sys/user/info')
				.then(({ data: res }) => {
					if (res.code !== 0) {
						return this.$message.error(res.msg)
					}
					this.infodata = res.data
				})
			this.dialogVisible = false
		},
		// 修改密码
		updatePasswordHandle() {
			this.updatePasswordVisible = true
			this.$nextTick(() => {
				this.$refs.updatePassword.init()
			})
		},
		qufabu() {
			const routeParams = {
				routeName: `platttask-add`,
				title: `发布任务`,
				path: 'plat/platttask-add',
				params: {
					// dictTypeId: row.id
				}
			}
			// 动态路由
			addDynamicRoute(routeParams, this.$router)
		},
		goQuestion() {
			const routeParams = {
				routeName: `sys-updatepassword`,
				title: `安全设置`,
				path: 'sys/sys-updatepassword',
				params: {
				}
			}
			// 动态路由
			addDynamicRoute(routeParams, this.$router)
		},
		xinzeng() {
			// 路由参数
			const routeParams = {
				routeName: `${this.$route.name}__合同管理`,
				title: `合同管理`,
				path: 'plat/platcontract-add-or-update',
				params: {
				}
			}
			// 动态路由
			addDynamicRoute(routeParams, this.$router)
		},
		jieshou() {
			if (this.infodata.userStatus == 0) {
				this.$alert('个人身份未认证，请先扫码进入公众号认证！', this.$t('prompt.title'), {
					confirmButtonText: this.$t('confirm')
				})
				return false
			}
			// 路由参数
			const routeParams = {
				routeName: `${this.$route.name}__接收任务`,
				title: `接收任务`,
				path: 'task/task-list',
				params: {
				}
			}
			// 动态路由
			addDynamicRoute(routeParams, this.$router)
		},
		grchakan() {
			if (this.infodata.userStatus == 0) {
				this.$alert('个人身份未认证，请先扫码进入公众号认证！', this.$t('prompt.title'), {
					confirmButtonText: this.$t('confirm')
				})
				return false
			}

			this.$router.push({ name: 'plat-plattaskaccept' })
		},
		// 退出
		logoutHandle() {
			this.$alert('设置角色成功，需要退出重新登录！', this.$t('prompt.title'), {
				confirmButtonText: this.$t('confirm'),
				callback: action => {
					this.$http.post('/auth/oauth/logout').then(({ data: res }) => {
						if (res.code !== 0) {
							return this.$message.error(res.msg)
						}
						this.$router.push({ name: 'login' })
						clearLoginInfo()
					}).catch(() => { })
				}
			})
		}
	}
}
</script>
<style lang="scss">
.dialogStyle .el-dialog__header {
	border-bottom: 1px solid #D2D2D2;
}

.dialogStyle .el-dialog__body {
	padding: 0px;
	margin: 10px 0px 20px 0px;
}

.select-tax-source {
	.el-input {
		width: 350px !important;
	}
}

.childAcctNo {
	line-height: 60px;
	color: red;
}

.dialog-main {
	.formItem {
		margin-bottom: 0;

		.el-input {
			width: 280px !important;
		}

		.copy {
			display: inline-block;
			width: 70px;
			text-align: end;
			cursor: pointer;
			color: #3A7DD1;
		}

		input {
			border: none;
			padding: 0;
		}

	}
}

.tax-source {
	margin: 20px 20px 0 0;
}


@media only screen and (max-width: 1500px) {
	.fontsize {
		font-size: 22px !important;
	}

	.cardCon {
		height: 220px !important;
		transform: scale(.9) !important;
		margin-top: -20px !important;
		padding: 0 !important;
	}

	.h2Title {
		margin-top: 15px !important;
		margin-bottom: 20px !important;
	}
}

.h2Title {
	img {
		margin-right: 5px;
	}

	font-size: 14px;
}

.box-card {

	.el-card__header {
		border: none;
	}

	.cardCon {

		height: 250px;
		// border-top:1px solid #ddd;
		// min-height: 300px;
		display: flex;
		align-items: center;
		justify-content: space-around;

		li {
			text-align: center;
			cursor: pointer;

			span {
				line-height: 1;
				margin-bottom: 15px;
				display: block;
				font-size: 48px;
				color: #282828;
			}

			p {
				font-size: 14px;
				color: #282828;
			}
		}

		&.cardCon1 {
			padding: 0 50px;

			li:nth-child(2) {
				width: 2px;
				height: 200px;
				background: #EAEAEA;
			}

			li p {
				width: 109px;
				height: 44px;
				background: #324EB8;
				border-radius: 22px;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 14px;
				color: #fff;
			}
		}

		dl {
			display: flex;
			align-items: center;
			justify-content: center;

			dt {
				width: 40px;
				height: 40px;
				margin-right: 20px;
			}

			dd {
				text-align: center;
				line-height: 1;
				position: relative;

				span {
					font-size: 36px;
					display: block;
					color: #282828;
					margin-bottom: 14px;
				}

				p {
					font-size: 12px;
					color: #282828;
				}

				.el-icon-refresh {
					position: absolute;
					right: -36px;
					top: -6px;
					font-size: 24px;
					cursor: pointer;
				}

				.refreshing {
					transform: rotate(-180deg);
					transition: all 0.5s;
				}
			}
		}

		&.cardCon2 {
			padding: 0 2%;

			li {
				width: 28%;
				height: 139px;
				border-radius: 10px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;

				img {
					width: 60px;
					height: 60px;
				}

				p {
					font-size: 14px;
					color: #fff;
					margin-top: 10px;
				}

				&:nth-child(1) {
					background: linear-gradient(139deg, #F78679, #FEC36C);
				}

				&:nth-child(2) {
					background: linear-gradient(139deg, #85FEE3, #70E4F8);
				}

				&:nth-child(3) {
					background: linear-gradient(139deg, #8FA1FD, #73ACFD);
				}
			}
		}
	}
}

.box-card3 {
	.el-card__header {
		background: #F5F5F5;
	}
}


.fkbTitle {
	font-size: 20px;
	color: #333;
	font-weight: bold;

	span {
		font-weight: normal;
		font-size: 16px;
		color: red;
	}
}
</style>